<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPin_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M10.145 8.607a7 7 0 0 0-1.473-.279c-1.724-.132-3.325.425-4.45 1.55l4.242 4.243-3.535 3.536a1 1 0 1 0 1.414 1.414l3.536-3.536 4.242 4.243c1.126-1.125 1.683-2.726 1.55-4.45a7 7 0 0 0-.278-1.473l4.21-5.565 1.59 1.589a1 1 0 0 0 1.414-1.415L19.07 4.93l-3.535-3.536a1 1 0 0 0-1.415 1.415l1.589 1.588z"
        clip-rule="evenodd"
    />
</svg>
